export const SiteConfig = {
    title: "PDFacture",
    description: "PDFacture est un outil pour générer un PDF d'une facturation à partir d'un formulaire",
} as const;